<template>
  <ForwardSalesPanelComponent
    :companyIds="company.id === undefined ? [] : [company.id]"
    :country="company.country"
  />
</template>

<script setup lang="ts">
import type { Company } from "@/types";
import ForwardSalesPanelComponent from "./ForwardSalesPanelComponent.vue";

/** The small-producer dashboard's forward sales: the materials and the company's active mandates by name. */
defineProps<{
  company: Company;
}>();
</script>
